<template>
  <Layout>
    <!-- 面包屑 -->
    <PageHeader :title="title" :items="items" />
    <!-- main -->
    <b-row>
      <b-col lg="12">
        <!-- 查询条件 -->
        <b-card>
          <b-row>
            <!--查询 input输入  -->
            <b-col lg="4">
              <b-form-group
                label="Question Name"
                label-cols-sm="4"
                label-align-sm="right"
                label-for="question-name"
              >
                <b-form-input
                  id="flavor-name"
                  v-model="search_condition.flavorName"
                  trim
                ></b-form-input>
              </b-form-group>
            </b-col>

            <!-- 状态选择下拉框 -->

            <b-col lg="4" class="ml-3">
              <b-form-group
                label="Question Status"
                label-cols-sm="4"
                label-align-sm="right"
                label-for="question-status"
              >
                <!-- <div class="deep"> -->
                <b-form-select
                  v-model="search_condition.status"
                  :options="options"
                ></b-form-select>
                <!-- </div> -->
              </b-form-group>
            </b-col>

            <!-- 搜索按钮 -->
            <b-col lg="2" class="ml-3">
              <b-button variant="primary" @click="search()">Search</b-button>
            </b-col>
          </b-row>
        </b-card>

        <b-card>
          <!-- table -->
          <b-button v-has="'questions::Create'" @click="gotoAdd" variant="primary"
            >Create</b-button
          >
          <div class="table-responsive mb-0">
            <b-table
              show-empty
              empty-text="no records"
              id="device-table"
              head-variant="light"
              ref="table"
              :busy="isBusy"
              :striped="true"
              :items="provider"
              :fields="fields"
              :per-page="search_condition.pageSize"
              :current-page="search_condition.pageNum"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-includedfields="filterOn"
              @filtered="onFiltered"
            >
              <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>

              <template v-slot:cell(index)="data">{{
                data.index +
                  (search_condition.pageNum - 1) * search_condition.pageSize +
                  1
              }}</template>

              <template v-slot:cell(actions)="row">
                <b-button-group>
                  <b-button
                    v-has="'questions::Modify'"
                    size="sm"
                    variant="info"
                    @click="edit(row.item, row.index, $event.target)"
                    class="mr-1"
                    >Modify</b-button
                  >

                  <b-button
                    v-if="row.item.status"
                    v-has="'questions::Disable'"
                    size="sm"
                    variant="danger"
                    @click="disable(row.item, row.index, $event.target)"
                    class="mr-1"
                  >
                    Disable
                  </b-button>

                  <b-button
                    v-else
                    v-has="'questions::Enable'"
                    size="sm"
                    variant="info"
                    @click="enable(row.item, row.index, $event.target)"
                    class="mr-1"
                  >
                    Enable
                  </b-button>
                </b-button-group>
              </template>
            </b-table>
          </div>
          <!-- end table -->
          <!-- pagination -->
          <b-row v-if="has_data">
            <b-col>
              <div
                class="dataTables_paginate paging_simple_numbers float-right"
              >
                <ul class="pagination mb-0" v-if="rows != 0">
                  <b-pagination
                    ref="page"
                    v-model="search_condition.pageNum"
                    :per-page="10"
                    :total-rows="rows"
                    aria-controls="table"
                  ></b-pagination>
                </ul>
              </div>
            </b-col>
          </b-row>
          <!-- end pagination -->
        </b-card>
      </b-col>
    </b-row>
    <!-- end main -->
  </Layout>
</template>
<script>
import DatePicker from "vue2-datepicker";
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import timeZoneConversion from "@/components/widgets/timeZoneConversion";

/**
 * Flavor List component
 */
export default {
  components: {
    DatePicker,
    Layout,
    PageHeader,
  },
  data() {
    return {
      // 顶部标题
      title: "Questions List",
      // 面包屑数据
      items: [
        {
          text: "UNI-CORE",
          // href: "/"
        },
        {
          text: "Medical Manage",
          // href: "/"
        },
        {
          text: "Questions List",
          active: false,
        },
      ],
      options: [
        { value: "", text: "" },
        { value: 1, text: "active" },
        { value: 0, text: "inactive" },
      ],
      tableData: [],
      totalRows: 0,
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: false,
      fields: [
        { key: "index", label: "#", class: "text-center" },
        { key: "questionName", label: "Question Name", class: "text-center" },
        {
          key: "questionCategory",
          label: "Question Category",
          class: "text-center",
        },

        {
          key: "status",
          label: "Status",
          class: "text-center",
          formatter: (value) => {
            return value == 1 ? "active" : "inactive";
          },
        },
        {
          key: "activatedTimes",
          label: "Activated Time",
          class: "text-center",
          formatter: (value) => {
            if (value) {
              return timeZoneConversion.getLocalTime(value);
            } else {
              return "";
            }
          },
        },
        { key: "actions", label: "Opreration", class: "text-center" },
      ],
      search_condition: {
        pageNum: 1,
        pageSize: 10,
        type: "1",
        flavorName: "",
        status: "",
        // deviceNumber: "",
        // deviceCoding: "",
        // brandName: "",
        // createTime: "",
        // modelName: "",
        // batchNumber: "",
        // number: "",
        // batchQuantity: "",
        // activatedQuantity: "",
        // supplierName: ""
      },
      isBusy: false,
      has_data: false,
    };
  },
  computed: {
    /**
     * 计算rows
     */
    rows() {
      return this.totalRows;
    },
  },
  mounted() {},
  methods: {
    provider(ctx) {
      this.isBusy = true;
      return this.$api.Question.list(this.search_condition, ctx)
        .then((x) => {
          this.isBusy = false;
          if (x.total) {
            this.has_data = true;
            this.totalRows = x.total;
            return x.data;
          } else {
            this.has_data = false;
            return [];
          }
        })
        .catch((e) => {
          this.isBusy = false;
          this.has_data = false;
          return [];
        });
    },
    search() {
      this.search_condition.pageNum = 1;
      this.$refs.table.refresh();
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.search_condition.pageNum = 1;
    },
    gotoAdd() {
      this.$router.push("/medicalManage/questionsAdd");
    },
    edit(item, index, button) {
      this.$router.push("questionsEdit?id=" + item.id);
    },
    del(a, b, c) {
      this.$api.Question.del({ id: a.id }).then((res) => {
        if(res.message){
              this.$bvToast.toast(res.message);
            }
        if (res.success) {
          this.$refs.table.refresh();
        }
      });
    },
    disable(a, b, c) {
      this.$api.Question.disable({ id: a.id }).then((res) => {
        if(res.message){
              this.$bvToast.toast(res.message);
            }
        if (res.success) {
          this.$refs.table.refresh();
        }
      });
    },
    enable(a, b, c) {
      this.$api.Question.enable({ id: a.id }).then((res) => {
        if(res.message){
              this.$bvToast.toast(res.message);
            }
        if (res.success) {
          this.$refs.table.refresh();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
